import loader from '../moduleLoader';
import Flickity from 'flickity';

class Slider {
    constructor(container) {
        this.container = container;
    }
    init() {
        if(document.body.classList.contains('edit-mode') == false && this.container.children.length > 1) {
            var flkty = new Flickity(this.container, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true
            });
        }
    }
}

loader.add('Slider', Slider);
export default Slider;